(function () {
  /* Bundle pricing display + mixed colors + free Memory Magnet.
     Prices are calculated locally. Nothing touches the cart on page load.
     The cart is only called when the shopper clicks Add to cart, Buy it now
     or the sticky button, and only when the order has mixed colors or the
     free magnet. Single-color 1 or 2 kit orders use Shopify's normal form. */

  var DISCOUNTS = { 1: 0, 2: 999, 3: 1998 };
  /* discount in cents: 2 kits save $9.99 ($49.99 total), 3 kits save $19.98 ($69.99 total).
     Update these if you change your Shopify automatic discounts. */

  function init() {
    document.querySelectorAll('[data-paw-product]').forEach(function (root) {
      if (root.dataset.bundleReady) return;
      root.dataset.bundleReady = 'true';
      var form = root.querySelector('form.paw-buy-form'), select = root.querySelector('.paw-variant-select');
      if (!form || !select) return;
      var sticky = document.querySelector('[data-paw-sticky][data-form="' + form.getAttribute('id') + '"]');
      var currency = root.dataset.currency;
      var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:currency});
      function money(cents) { return formatter.format(cents / 100); }
      var qtyInput = form.querySelector('[data-paw-qty]');
      var isKit = root.dataset.isKit === 'true';
      var colorsBox = root.querySelector('[data-paw-kit-colors]');
      var giftBox = root.querySelector('[data-paw-gift]');
      var giftSelect = root.querySelector('[data-paw-gift-select]');
      var kitSelects = Array.prototype.slice.call(root.querySelectorAll('[data-kit-select]'));
      var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var busy = false;

      function currentQuantity() {
        var checked = form.querySelector('[name="paw_bundle"]:checked');
        return checked ? Number(checked.value) : 1;
      }

      /* extra kits follow the main color until the shopper changes them */
      function syncKitSelects() {
        kitSelects.forEach(function (s) {
          if (s.dataset.touched) return;
          var option = s.querySelector('option[value="' + select.value + '"]');
          if (option && !option.disabled) s.value = select.value;
        });
      }

      function display() {
        var qty = currentQuantity();
        qtyInput.value = qty;
        var option = select.selectedOptions[0], unit = Number(option.dataset.cents);
        [1,2,3].forEach(function (amount) {
          var total = root.querySelector('[data-paw-total="'+amount+'"]');
          if (!total) return;
          var before = unit * amount;
          var discount = DISCOUNTS[amount] || 0;
          total.textContent = money(before - discount);
          var was = root.querySelector('[data-paw-was="'+amount+'"]'), saving = root.querySelector('[data-paw-saving="'+amount+'"]');
          if (was) { was.textContent = money(before); was.hidden = discount === 0; }
          if (saving) { saving.textContent = 'Save ' + money(discount); saving.hidden = discount === 0; }
        });
        if (colorsBox) {
          colorsBox.hidden = qty < 2;
          root.querySelectorAll('[data-kit-row]').forEach(function (row) {
            row.hidden = Number(row.dataset.kitRow) > qty;
          });
        }
        if (giftBox) giftBox.hidden = qty !== 3;
        if (sticky) {
          var stickyPrice = root.querySelector('[data-paw-total="'+qty+'"]');
          if (stickyPrice) sticky.querySelector('[data-paw-sticky-price]').textContent = stickyPrice.textContent;
          sticky.disabled = option.dataset.available !== 'true';
        }
      }

      function cartItems() {
        var qty = currentQuantity();
        var counts = {}, order = [];
        function add(id) {
          if (!counts[id]) { counts[id] = 0; order.push(id); }
          counts[id] += 1;
        }
        add(select.value);
        for (var n = 2; n <= qty; n++) {
          var s = root.querySelector('[data-kit-select="'+n+'"]');
          add(isKit && s ? s.value : select.value);
        }
        var items = order.map(function (id) { return { id: Number(id), quantity: counts[id] }; });
        if (isKit && qty === 3 && giftSelect && giftSelect.value) {
          items.push({ id: Number(giftSelect.value), quantity: 1 });
        }
        return items;
      }

      form.addEventListener('submit', function (event) {
        if (!isKit) return;
        var items = cartItems();
        if (items.length === 1) return; /* one color, no gift: normal Shopify add to cart */
        event.preventDefault();
        if (busy) return;
        busy = true;
        var submitter = event.submitter || root.querySelector('.paw-add');
        var buyNow = submitter && submitter.name === 'return_to';
        var buttons = form.querySelectorAll('button[type="submit"]');
        var original = submitter ? submitter.textContent : '';
        buttons.forEach(function (b) { b.disabled = true; });
        if (submitter) submitter.textContent = 'Adding…';
        fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            window.location.href = routesRoot + (buyNow ? 'checkout' : 'cart');
          })
          .catch(function () {
            busy = false;
            buttons.forEach(function (b) { b.disabled = false; });
            if (submitter) submitter.textContent = original;
            window.alert('Sorry, one of your selected colors may be sold out. Please choose a different color and try again.');
          });
      });

      select.addEventListener('change', function () { syncKitSelects(); display(); });
      kitSelects.forEach(function (s) {
        s.addEventListener('change', function () { s.dataset.touched = 'true'; });
      });
      form.querySelectorAll('[name="paw_bundle"]').forEach(function (input) { input.addEventListener('change', display); });

      if (sticky) {
        sticky.addEventListener('click', function () { form.requestSubmit(root.querySelector('.paw-add')); });
        var observer = new IntersectionObserver(function (entries) { sticky.hidden = entries[0].intersectionRatio === 1; }, { threshold: 1 });
        observer.observe(root.querySelector('.paw-add'));
      }

      syncKitSelects();
      display();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
